import React from 'react';
import soundCloud from '../Assets/soundCloud.gif'
import { DiCss3,DiMongodb, DiReact, DiMysql, DiNodejs, DiRedis } from "react-icons/di";
import { SiExpress, SiChakraui } from "react-icons/si";
export const holeThing = [
    {
      icons : [ <SiExpress />, <DiNodejs />, <DiMysql />, <DiMongodb />, <DiRedis />],
      gifSource : "MovieClubHomePic.png",
      headers : "MovieClub",
      liveCode : "https://movieclub.marcustheatres.com/",
      sourceCode : "",
      main : "This premium subscription plan for Marcus Theatres offers exclusive movie experiences and perks for true movie lovers.",
      body : "The website was developed by the Influx Worldwide team, with my contribution to the backend, ensuring seamless API integration for both the site and application.",
    },
    {
      icons : [<SiExpress />, <DiNodejs />, <DiMysql />, <DiMongodb />, <DiRedis />],
      gifSource : "CmxPassport.png",
      headers : "Cmx Passport",
      liveCode : "https://passport.cmxcinemas.com/",
      sourceCode : "",
      main: "This is also a premium subscription plan for CMX Theatres.",
      body: "The website was developed by the Influx Worldwide team. I contributed to the backend, and the same API is used for the application as well."
    },
    {
      icons : [<SiChakraui />,<DiReact />,<DiCss3 />,<DiMongodb />,<SiExpress />],
      gifSource : soundCloud,
      headers : "soundCloud Clone",
      liveCode : "https://web-jinke-music.vercel.app/",
      sourceCode : "https://github.com/BhaveshSuthar00/soundCld-client-side",
      main : "This is an online audio streaming and distribution platform that allows users to stream, share music, and podcasts.",
      body : "This was a collaborative group project during my time at Masai School."
    }
  ]